import type { useCheckoutFlow } from '../../../checkout/flow'
import type { ShopMessageKey } from '../../../i18n'

type CheckoutViewModel = ReturnType<typeof useCheckoutFlow>['viewModel']

type CheckoutErrorBannerProps = {
  viewModel: CheckoutViewModel
  t: (key: ShopMessageKey) => string
  toLocalizedPath: (path: string) => string
}

export const CheckoutErrorBanner = ({ viewModel, t, toLocalizedPath }: CheckoutErrorBannerProps) => {
  if (!viewModel.errorMessage) return null

  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900" role="alert" aria-live="polite">
      <p>{viewModel.errorMessage}</p>
      <div className="mt-2 flex flex-wrap gap-2">
        {viewModel.canRetryError ? (
          <button
            type="button"
            className="rounded-md border border-amber-300 bg-white px-2.5 py-1 text-xs font-semibold text-amber-900 transition hover:bg-amber-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400"
            onClick={viewModel.onRetryBootstrap}
          >
            {t('checkout.cta.retry')}
          </button>
        ) : null}
        {viewModel.canGoBackToCart ? (
          <button
            type="button"
            className="rounded-md border border-amber-300 bg-white px-2.5 py-1 text-xs font-semibold text-amber-900 transition hover:bg-amber-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400"
            onClick={() => {
              window.location.assign(toLocalizedPath('/cart'))
            }}
          >
            {t('checkout.cta.backToCart')}
          </button>
        ) : null}
        <button
          type="button"
          className="rounded-md border border-amber-300 bg-white px-2.5 py-1 text-xs font-semibold text-amber-900 transition hover:bg-amber-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400"
          onClick={viewModel.clearError}
        >
          {t('checkout.cta.dismiss')}
        </button>
      </div>
    </div>
  )
}
